export default "__VITE_ASSET__CYepfwyE__"